// extracted by mini-css-extract-plugin
export default {"grey":"#dedcdb","green":"#135e63","blue":"#202fcf","purple":"#5503b2","darkRed":"#321e23","darkBlue":"#243e6f"};